import { Vector3 } from 'three';
import ObjectView from '@scene/views/object-view';
import Axis from '@scene/axis';

export const CameraOrientations = {
  CONFIG_1: {
    perspectiveCamera: {
      position: new Vector3(760, 535, 230)
    }
  },
  CONFIG_2: {
    perspectiveCamera: {
      position: new Vector3(460, 590, -550)
    }
  },
  CONFIG_3: {
    perspectiveCamera: {
      position: new Vector3(760, 535, 230)
    }
  },
};

export default {
  mode: ObjectView.mode.MODE_3D,
  orthographicCamera: {
    position: new Vector3(0.0007121568184116151, 712.1446482277966, -0.000005268009116589875),
    zoom: 10
  },
  perspectiveCamera: {
    position: CameraOrientations.CONFIG_1.perspectiveCamera.position,
    target: new Vector3(61.911263501388774, -33.2887594838193, -91.75690968561267),
    zoom: 1
  },
  axis: {
    position: null,
    orientation3D: Axis.types.Z_TOP,
    orientation2D: Axis.types.Y_TOP_2D
  }
};



// WEBPACK FOOTER //
// ./src/reducers/camera/defaults/woodConnection.js